import Button from 'components/Button'
import BaseModal from 'components/modals/BaseModal'
import moment from 'moment'

interface IProps {
  title: string
  postedTimestamp: Date
  url: string
  onClose?: Callback
  width?: number
  height?: number
}

const defaultWidth = 560
const defaultHeight = 315

function VideoEmbedModal({
  title,
  postedTimestamp,
  url,
  onClose,
  width = defaultWidth,
  height
}: IProps) {
  const autoHeight = height || (width * defaultHeight) / defaultWidth

  return (
    <BaseModal onClose={onClose} classNames="sm:max-w-xl md:max-w-3xl">
      <div className="relative px-10 pt-4">
        <h3 className="text-lg text-gray-800 font-bold">{title}</h3>
        <p className="text-sm text-gray-500 font-light">
          Posted {moment(postedTimestamp).fromNow()}
        </p>

        <div className="flex justify-center pt-6">
          <iframe
            width={width}
            height={autoHeight}
            src={url}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>

      <div className="bg-gray-50 flex justify-end py-3 px-6 mt-10">
        <Button onClick={onClose} color="white" label="Close" />
      </div>
    </BaseModal>
  )
}

export default VideoEmbedModal
